import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.333 6.666 8 9.333l2.667-2.667M2.667 2h10.666a1.333 1.333 0 0 1 1.334 1.333v4a6.667 6.667 0 0 1-13.334 0v-4A1.333 1.333 0 0 1 2.667 2" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }